var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-yellow-100"},[_vm._t("default"),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"u-center p-4"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }